import React, { useState } from "react";
import { Typography, Link, Grid, Chip, Box } from "@material-ui/core";
import { Primary } from "../../config/colors";
import { makeStyles } from "@material-ui/core/styles";
import DeleteEditActionButtons from "../../components/DeleteEditActionButtons/DeleteEditActionButtons";

const useStyles = makeStyles((theme) => ({
  root: {},
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  active: {
    "& > div": {
      backgroundColor: Primary.light,
    },
  },
}));

const SingleCompany = ({
  shortVersion,
  isActive,
  onSelect,
  onRemove,
  company,
  onShowSignals,
  onUpdate,
  ...props
}) => {
  const classes = useStyles();

  const [rerender, setRerender] = useState(false);

  React.useEffect(() => {
    setRerender((prev) => !prev);
  }, [props.rerenderbit]);

  const getPrimaryData = (contacts, type) => {
    if (!contacts || contacts.length < 1) return null;
    const primary = contacts.find((contact) => contact.is_primary);
    if (primary) {
      switch (type) {
        case "email":
          return primary.contact_email;
        case "name":
          return `${primary.contact_first_name} ${primary.contact_last_name}`;
        case "mobile":
          return primary.contact_mobile;

        default:
          break;
      }
    }
    return null;
  };

  return (
    <React.Fragment>
      <Grid container spacing={2} justify="flex-start" alignItems="center">
        <Grid
          item
          //xs={shortVersion ? 12 : 2}
          xs={2}
        >
          <Typography variant="subtitle1" className={classes.row}>
            <Link
              style={{
                cursor: "pointer",
                textDecoration: "none",
              }}
              color="textPrimary"
              onClick={() => onSelect(company.id)}
            >
              {company.name}
            </Link>
          </Typography>
        </Grid>

        <React.Fragment>
          <Grid item xs={1}>
            <Typography variant="body1" color="textSecondary">
              {company.id}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {company.cities &&
              company.cities.length > 0 &&
              company.cities.map((city) => (
                <Chip label={city} key={city} style={{ marginRight: 4 }} />
              ))}
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body1" color="textSecondary">
              {getPrimaryData(company.contacts, "name")}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="body1" color="textSecondary">
              {getPrimaryData(company.contacts, "email")}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="body1" color="textSecondary">
              {getPrimaryData(company.contacts, "mobile")}
            </Typography>
          </Grid>
          <Grid item xs={1} style={{ textAlign: "center" }}>
            <Chip
              clickable
              disabled={!company.is_signal}
              color="primary"
              size="small"
              label={!company.is_signal ? "N/A" : "Show"}
              onClick={() => onShowSignals(company.id)}
            />
          </Grid>
          <Grid item xs={1}>
            <Box maxWidth={80} m="auto">
              <DeleteEditActionButtons
                onRemove={() => onRemove(company.id)}
                onEdit={() => onUpdate(company.id)}
              />
            </Box>
          </Grid>
        </React.Fragment>
      </Grid>
    </React.Fragment>
  );
};
export default SingleCompany;
